export enum HazardTab {
	Overview = 'tab-overview',
	Service = 'tab-service',
	Device = 'tab-device',
	CustomFields = 'tab-custom-fields',
	Contacts = 'tab-contacts',
	SiteHazards = 'tab-siteHazards'
}
